import { StatTile } from "@bednbody/ui/components/stat-tile";
import type { Icon } from "@phosphor-icons/react";
import { cn } from "@bednbody/ui/lib/utils";

interface StateSummaryProps {
  /**
   * `icon` is per item, not per row: one shared glyph across six different
   * states told the reader nothing, and these six are the states an operator
   * scans this page for.
   */
  items: readonly { label: string; value: number; icon: Icon; tone?: string }[];
  isLoading: boolean;
}

/** The stat-card row shared by the Live and Outcomes panels. */
export function StateSummary({ items, isLoading }: StateSummaryProps) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {items.map((item) => (
        <StatTile key={item.label} layout="compact" label={item.label} icon={item.icon}>
          <p className={cn("text-2xl font-semibold tabular-nums", item.tone ?? "text-foreground")}>
            {isLoading ? "…" : item.value}
          </p>
        </StatTile>
      ))}
    </div>
  );
}
